/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";
import { useIcon } from "Utils";

/**
 * Import required elements
 */
import BackgroundRender from "./render";

/**
 * Background Component
 */
function Background(props) {
  const { backgroundFile, timestamp } = props;

  const fileUid = backgroundFile ? backgroundFile.uid : null
  const background = useIcon(fileUid, timestamp);

  let { className, condition, children } = props;

  return React.createElement(BackgroundRender, {
    className,
    condition,    
    background
  }, children);
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => {
  let { backgroundFile } = state.simtopy;
  let file = backgroundFile ? state.list.file[backgroundFile.uid] : null
  let { timestamp } = file || backgroundFile || {};
  return { backgroundFile, timestamp };
})(Background);
